<template>
  <div id="SendMessage">
      
    <div class="row">
      <div class="col-xs-12 ">
        <p class="card-text csp-banner-text csp-margin-top">
        If you have any questions or need to change any information, 
        please send us a message using the form below. Thank you!</p>
      </div>                
    </div>
    
    <div class="row">
      <div class="col-xs-12">
        <form>
          
          <div class="md-form">
            <textarea type="text" id="csp-message" class="md-textarea" v-model="message"></textarea>
            <label for="csp-message">Message</label>
          </div>
        </form>
      </div>
    </div>
            
  </div>
</template>

<script>
  export default {
    name: 'SendMessage',
    computed: {
      message: {
        get: function () {
          return this.$store.getters.message
        },
        set: function (newValue) {
          this.$store.commit('updateMessage', newValue)
        }
      }
    }
  }
</script>

<style scoped>

  .csp-banner-text{
    text-align: start;
  }

  .csp-margin-top{
    margin-top: 4vh;
  }
  
  /* All Mobile Sizes (devices and browser) */
  @media only screen and (max-width: 767px) {



  }
  
  @media only screen and (min-width: 480px) and (max-width: 767px) {

  }
  
  
  @media only screen and (max-width: 479px) {

  }
</style>



// WEBPACK FOOTER //
// SendMessage.vue?7ca71596